import { createSlice } from "@reduxjs/toolkit";
import { fetchDashboardDetails, fetchDashboardStats } from "./dashboardActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const dashboardStats = createSlice({
  name: "dashboardStats",
  initialState: {
    dashboardStatsLoading: false,
    dashboardStatsData: [],
    dashboardErrorStats: null,
  },
  reducers: {
    updateKeyElements: (state, action) => {
      state.dashboardStatsData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.dashboardStatsLoading = true;
        state.dashboardErrorStats = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.dashboardStatsLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.dashboardStatsData = [];
            state.dashboardErrorStats = false;
          } else {
            state.dashboardErrorStats = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.dashboardErrorStats = false;
          state.dashboardStatsData = action.payload?.data?.data;
        }
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.dashboardStatsLoading = false;
        state.dashboardErrorStats = action.error.message;
      });
  },
});

const dashboardDetails = createSlice({
  name: "dashboardDetails",
  initialState: {
    dashboardDetailsLoading: false,
    dashboardDetailsData: [],
    dashboardDetailsErrorStats: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardDetails.pending, (state) => {
        state.dashboardDetailsLoading = true;
        state.dashboardDetailsErrorStats = null;
      })
      .addCase(fetchDashboardDetails.fulfilled, (state, action) => {
        state.dashboardDetailsLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.dashboardDetailsData = [];
            state.dashboardDetailsErrorStats = false;
          } else {
            state.dashboardDetailsErrorStats = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.dashboardDetailsErrorStats = false;
          state.dashboardDetailsData =
            action.payload?.data?.data?.practiceExtendedResponseDTO;
        }
      })
      .addCase(fetchDashboardDetails.rejected, (state, action) => {
        state.dashboardDetailsLoading = false;
        state.dashboardDetailsErrorStats = action.error.message;
      });
  },
});

export const { updateKeyElements } = dashboardStats.actions;
export const dashboardStatsReducer = dashboardStats.reducer;
export const dashboardDetailsReducer = dashboardDetails.reducer;
